<div class="image-container">
    <img class="bottom-image" [src]="src" [style.max-width.px]="maxWidth ? maxWidth : undefined" [style.width.px]="width ? width : undefined" [style.max-height.px]="maxHeight ? maxHeight : undefined" [style.height.px]="height ? height : undefined">
    <img class="card-img-top top-image"
         [src]="src" [alt]="alt" [style.max-width.px]="maxWidth ? maxWidth : undefined" [style.width.px]="width ? width : undefined"
         [style.max-height.px]="maxHeight ? maxHeight : undefined" [style.height.px]="height ? height : undefined"
         [default]="default">
</div>

